import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostMusiciencat(action) {
	try {
		const result = yield fromApi.musicienscatPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_MUSICIENCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetMusicienscats(action) {
	try {
		const result = yield fromApi.musicienscatsGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_MUSICIENCATS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutMusicienscat(action) {
	try {
		const result = yield fromApi.musicienscatPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_MUSICIENCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelMusiciencat(action) {
	try {
		const result = yield fromApi.musicienscatDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_MUSICIENCAT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* musicienscats() {
	yield takeLatest('POST_MUSICIENCAT_SAGAS', watchPostMusiciencat);
	yield takeLatest('GET_MUSICIENCATS_SAGAS', watchGetMusicienscats);
	yield takeLatest('PUT_MUSICIENCAT_SAGAS', watchPutMusicienscat);
	yield takeLatest('DEL_MUSICIENCAT_SAGAS', watchDelMusiciencat);
}

export default function* rootSaga() {
	yield all([musicienscats()]);
}
